import {
    Box,
    Button,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { formatData } from 'lib/functions';
import { safeSetState } from 'lib/reactUtils';
import { AlertInformation } from 'components';
import { ASITUACAO_FOLLOWUP_ENCERRADO } from 'consts';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getApiErrorMessage, getRecordFromResponse, getResponseData } from 'lib/formUtils';

class FollowUpHistorico extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        followups: [],
        isLoading: true,
        openAlert: false,
        messageAlert: ''
    };

    /* Carrega o histórico do follow up */
    async componentDidMount() {
        this._isMounted = true;

        const id = this.props.match?.params?.id;

        try {
            // busca o registro atual
            const responseAtual = await api.get(`/followup/${id}`);
            const registroAtual = getRecordFromResponse(responseAtual);

            if (!registroAtual) {
                this.handleOpenAlert('Follow up não encontrado!');

                this.safeSetState({ isLoading: false });

                return;
            }

            const response = await api.get(
                `/followup?codfollowuporig=${registroAtual.codfollowuporig}&limit=200`
            );

            this.safeSetState({
                followups: getResponseData(response),
                isLoading: false
            });
        } catch (error) {
            console.error(
                'Erro ao carregar o histórico do follow up:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao carregar o histórico do follow up!')
            );

            this.safeSetState({ isLoading: false });
        }
    };

    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Clicar para voltar */
    onClickVoltar = () => {
        const id = this.props.match?.params?.id;
        const path = this.props.match?.path || '/crm/followup/:id/historico';
        const basePath = path.replace('/:id/historico', '');

        this.props.history.push(`${basePath}/${id}`);
    };

    render() {
        const {
            followups,
            isLoading,
            messageAlert,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Histórico do follow up
                        </Typography>

                        <Button
                            variant="contained"
                            size="medium"
                            color="secondary"
                            onClick={this.onClickVoltar}
                            style={{ textTransform: 'none' }}
                        >
                            VOLTAR
                        </Button>
                    </Box>

                    <br />

                    {isLoading ? (
                        <Typography variant="body1">
                            Carregando histórico...
                        </Typography>
                    ) : (
                        <Card>
                            <CardContent>
                                <PerfectScrollbar>
                                    <div>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">Código</TableCell>

                                                    <TableCell align="center">Contato</TableCell>

                                                    <TableCell align="center">Assunto</TableCell>

                                                    <TableCell align="center">Situação</TableCell>

                                                    <TableCell align="center">Próximo follow up</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {followups.length === 0 && (
                                                    <TableRow>
                                                        <TableCell
                                                            align="center"
                                                            colSpan={5}
                                                        >
                                                            Nenhum follow up encontrado
                                                        </TableCell>
                                                    </TableRow>
                                                )}

                                                {followups.map(followup => {
                                                    const isEncerrado = followup.situacao === ASITUACAO_FOLLOWUP_ENCERRADO;
                                                    const estiloSituacao = isEncerrado ? { color: 'green' } : {};

                                                    return (
                                                        <TableRow
                                                            hover
                                                            key={followup.codfollowup}
                                                        >
                                                            <TableCell
                                                                align="center"
                                                                style={estiloSituacao}
                                                            >
                                                                {followup.codfollowup}
                                                            </TableCell>

                                                            <TableCell
                                                                align="center"
                                                                style={estiloSituacao}
                                                            >
                                                                {followup.nomecontato}
                                                            </TableCell>

                                                            <TableCell
                                                                align="center"
                                                                style={estiloSituacao}
                                                            >
                                                                {followup.assunto}
                                                            </TableCell>

                                                            <TableCell
                                                                align="center"
                                                                style={estiloSituacao}
                                                            >
                                                                {isEncerrado ? 'Encerrado' : 'Em aberto'}
                                                            </TableCell>

                                                            <TableCell
                                                                align="center"
                                                                style={estiloSituacao}
                                                            >
                                                                {formatData(followup.proximofollowup)}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </PerfectScrollbar>
                            </CardContent>
                        </Card>
                    )}
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

FollowUpHistorico.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object
};

export default FollowUpHistorico;